module.exports = __webpack_public_path__ + "img/desktop.ed9dd4e0.svg";